<template>
    <v-row :class="mt ? 'mt-4' : null" v-if="vIf">
        <v-col cols="12" :sm="sm" class="py-0">
            <v-row>
                <v-col cols="12" class="py-0 caption">
                    <span>{{ heading }}</span>
                </v-col>
            </v-row>
            <v-row>
                <slot />
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
export default {
    props: {
        heading: String,
        vIf: { type: Boolean, default: true },
        mt: { type: Boolean, default: true },
        sm: { type: Number, default: 6 },
    },
};
</script>